const interval = setInterval(() => {
    const elements = document.querySelectorAll('.tmenu-watermark');
    if (elements.length > 0) {
        
        elements.forEach(el => {
            el.innerHTML = "";
        });
        clearInterval(interval);
    }
    document.addEventListener("mouseover", function(e) {

        const item = e.target.closest(".tmenu_item");
       
        if (item) {
            const target = item.querySelector(".tmenu-watermark");

            if (target) {
                target.innerHTML = "";
            }
        }
        //alert(window.innerWidth);
        if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
            /*
                document.addEventListener("mouseover", function(e) {
                    const item = e.target.closest("li.tmenu_item_submenu_type_automatic");

                

                        if (item) {
                            //alert("here");
                            item.className = ""; // remove all classes
                            item.classList.add("tmenu_item tmenu_item_level_0 tmenu_item_submenu_type_automatic tmenu_item_has_child tmenu_item_active tmenu_item_mobile nav-item tmenu_item--current"); // add your class
                            

                        }
                });
                document.addEventListener("mouseover", function(e) {
                    const item = e.target.closest("ul.tmenu_submenu--desktop");

                

                        if (item) {
                            //alert("here");
                            item.className = ""; // remove all classes
                            item.classList.add("tmenu_submenu_type_automatic tmenu_submenu--mobile tmenu_submenu"); // add your class
                            

                        }
                });
            */

        }

    });
    jQuery(document).ready(function($) {
        
        
            var filterdata = $("#fdt-search-filters-app").data('collection-handle');  
            //alert(filterdata);
            if(filterdata == "all")
            {
                    $("#collection-Collection-target-option").show();
            }
            else{
                $("#collection-Collection-target-option").hide();
            }
            $('#fdt-container').addClass('container');
            $('#fdt-search-filters-app').addClass('row');
            $('.search-filters__layout').addClass('col-md-12 col-lg-12 col-xl-12');
            if (window.innerWidth >= 300 && window.innerWidth <= 600) {
                    $('#qikify-tmenu-megamenu-1').addClass('scroll-active');
                    $('li.tmenu_item_level_1 span.tmenu_indicator span svg').click(function(e) {
                        var parentUl = $(this).closest('li.tmenu_item_level_0').parent('ul');
                        $('li.tmenu_item_level_1').removeClass('tmenu_item_active');
                        $(this).closest('li.tmenu_item_level_0').addClass('tmenu_item_active');
                        //parentUl.toggleClass('scroll-active');
                        if (!parentUl.hasClass('scroll-active')) {
                                parentUl.addClass('scroll-active');
                        }
                    });
                    
                    $('li.tmenu_item_level_0 span.tmenu_indicator span svg').click(function(e) {
                        var parentUl = $(this).closest('li.tmenu_item_level_0');
                        $('li.tmenu_item_level_0').removeClass('tmenu_item_active');
                        $('#qikify-tmenu-megamenu-1').removeClass('scroll-active');
                        //parentUl.toggleClass('scroll-active');
                        $(this).closest('li.tmenu_item_level_0').addClass('tmenu_item_active');
                    });
            }

            $('input[name="min"]').prev('span').text('From (AUD)');
            $('input[name="max"]').prev('span').text('To (AUD)');

            $('.wysh-badge-container span.svg-wrapper').html('<svg width="185" height="162" viewBox="0 0 185 162" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_29_11)"><path d="M132.259 1.04188e-08C118.435 1.04188e-08 107.359 4.963 97.5838 14.738L97.5668 14.755H97.5608L92.0058 21.755L86.4508 15.182L86.4338 15.165H86.4278C76.6528 5.382 65.5778 1.04188e-08 51.7538 1.04188e-08C41.52 3.96063e-05 31.5159 3.03413 23.0061 8.71875C14.4963 14.4034 7.86286 22.4833 3.94429 31.9372C0.0257123 41.3911 -1.00208 51.7945 0.990833 61.8324C2.98374 71.8704 7.90789 81.0921 15.1408 88.332L83.8408 157.607C84.9099 158.685 86.1819 159.541 87.5834 160.125C88.9848 160.709 90.4881 161.009 92.0063 161.009C93.5246 161.009 95.0278 160.709 96.4293 160.125C97.8308 159.541 99.1027 158.685 100.172 157.607L168.866 88.332C176.1 81.093 181.025 71.8717 183.019 61.8339C185.013 51.796 183.986 41.3924 180.068 31.9381C176.15 22.4839 169.517 14.4036 161.007 8.71873C152.497 3.0339 142.493 -0.000205298 132.259 1.04188e-08Z" fill="#2B4482"/></g><defs><clipPath id="clip0_29_11"><rect width="184.013" height="161.011" fill="white"/></clipPath></defs></svg>');
           // $(".search-filters__product-item .search-filters__product-info .search-filters__format-currency").append("<p>New paragraph added with jQuery</p>");
    
    });
}, 200);
const intervaldata = setInterval(() => {
function equalHeight() {
  var maxHeight = 0;

  jQuery('.wysh-products li').each(function () {
    var h = jQuery(this).outerHeight();
    if (h > maxHeight) {
      maxHeight = h;
    }
  });

  jQuery('.wysh-products li').css('height', maxHeight + 'px');
  //alert("sffs");
}

jQuery(document).ready(function () {
  equalHeight();
});

jQuery(window).resize(function () {
  jQuery('.wysh-products li').css('height', 'auto'); // reset first
  equalHeight();
});
}, 300);
  
const interval2 = setInterval(() => {
jQuery(document).ready(function($) {
    
        var productData = JSON.parse(document.getElementById('ProductJson').textContent);
        var productDatavariation = JSON.parse(document.getElementById('ProductJson1').textContent);
        
        $(document).on('change', 'input[type="radio"]', function(){
            var $input = $(this);
            setTimeout(function(){
             var variantId = $input.data('variant-id');
             //alert("hhh");
             //alert(variantId);
             if (!variantId) return;

            var variant = productData.variants.find(function(v){
                return v.id == variantId;
            });
            /*
            var productDatavariationdata = productDatavariation.variants.find(function(v){
                return v.id == variantId;
            });*/
           
            var unitLabel = '';
            productDatavariation.variants.forEach(function(variant, index) {
                if(variant.id == variantId){
                     unitLabel = variant.metafields.custom.unit_label;
                    console.log('Unit Label:', unitLabel);
                }
                });
            if (variant) {
                var priceEx   = (variant.price / 100).toFixed(2);
                var priceIncl = ((variant.price / 100) * 1.10).toFixed(2);
                //var unitLabel = '';

                console.log('Variant:', variantId);
                console.log('Incl GST:', priceIncl);
                console.log('Ex GST:', priceEx);
                console.log(unitLabel);

                $('.product-details .price-inc').text('AUD ' + priceIncl + ' incl GST');
                $('.product-details .price-ex').text('AUD ' + priceEx + ' ex GST');
                $('.product-details .unit-label').text(unitLabel);
                const addToCartBtn = document.querySelector('.product-details .productcomponentquotebutton');
                const productrequestquotebutton = document.querySelector('.product-details .productrequestquotebutton');
                if(variant.price > 0)
                {
                    
                    addToCartBtn.style.display = 'block';
                    productrequestquotebutton.style.display = 'none';
                    $('.product-details .price-inc').show();
                    $('.product-details .price-ex').show();
                }
                else{
                    addToCartBtn.style.display = 'none';
                    productrequestquotebutton.style.display = 'block';
                    $('.product-details .price-inc').hide();
                    $('.product-details .price-ex').hide();

                }
                
            }
            }, 1500);
        });
});
}, 1500); 
